import SvgIcon from "./IconClose.svg?react";
const IconClose = SvgIcon;
export default IconClose;
